

function GoverningBodyName({ governingBody, style = null, className = null }) {
	let text = governingBody + " (Not known) ";

	switch(governingBody) {
		default:
			break;
		case 'CA_IWLS':
			text = 'Canadian Hydrographic Service';
			break;
		case 'CA_WSC':
			text = "Water Survey of Candada";
			break;
		case "EA":
			text = "The Environment Agency"
			break;
		case "NRW":
			text = "Natural Resources Wales";
			break;
		case "EA+NRW":
			text = "The Environment Agency (ENG) and Natural Resources Wales (WAL)";
			break;
		case "SEPA":
			text = "SEPA";
			break;
		case "EA+SEPA":
			text = "The Environment Agency (ENG) and SEPA (SCOT)";
			break;
		case "IE_EPA":
			text = "Environmental Protection Agency (IE)"
			break;
		case "IE_OPW":
			text = "Office of Public Works (IE)"
			break;
		case 'DE_PO':
			text = 'PegelOnline (DE)';
			break;
	}

	return <span style={style} className={className}>{text}</span>;
}

export default GoverningBodyName;